import React, { useState } from "react"
import clsx from "clsx"
import TextInputField from "../textInput"
import dayjs from "../../plugins/dayjs"
import { changeLocale } from "../../plugins/dayjs"
import { LOCALES } from "../../constants/locales"
import Calendar from "react-calendar"
import { getLocale } from "assets/languages"

interface Props {
  className?: string

  defaultValue?: any
  value?: any
  onClick?: any
  onChange?: any
  tileDisabled?: any

  minDate?: any
  maxDate?: any

  calenderHeader?: () => React.ReactNode
  placeholder?: any
  style?: any
}

const DatePicker = (props: Props) => {
  let className = clsx("date-picker", `${props.className}`)
  const [isCalendarVisible, setIsCalendarVisible] = useState(false)

  // Set Korean locale for dayjs
  changeLocale(dayjs, getLocale())

  return (
    <div className={className} style={props.style ? props.style : {}}>
      <TextInputField
        bordered
        placeholder={props.placeholder ? props.placeholder : ""}
        value={
          props.value
            ? dayjs(props.value).format("YY.MM.DD") +
              (props.value ? ` ${dayjs(props.value).format("ddd")}${getLocale() === "ko" ? "요일" : ""}` : "")
            : ""
        }
        defaultValue={props.defaultValue ? props.defaultValue : undefined}
        onChangeText={(value) => {
          if (!dayjs(value).isValid()) {
            return;
          }
          value = dayjs(value).format("YYYY-MM-DD")
          props.onChange ? props.onChange(value) : null
        }}
        onFocus={() => {
          setIsCalendarVisible(true)
        }}
        onPaste={(e) => {
          e.preventDefault();
        }}
        calendar={() => {
          return (
            <div className="absolute z-50">
              {isCalendarVisible && (
                <div
                  className="fixed top-0 left-0 w-full h-full bg-white opacity-50"
                  style={{ zIndex: -1 }}
                  onClick={(e) => {
                    setIsCalendarVisible(false)
                  }}
                ></div>
              )}
              {(props.calenderHeader != null && isCalendarVisible) && (
                props.calenderHeader()
              )}
              {isCalendarVisible && (
                <Calendar
                  calendarType="gregory"
                  className={`${isCalendarVisible ? "block" : "hidden"}`}
                  showWeekNumbers={false}
                  minDate={props.minDate ? props.minDate : null}
                  maxDate={props.maxDate ? props.maxDate : null}
                  defaultValue={props.defaultValue ? props.defaultValue : undefined}
                  value={props.value ? dayjs(props.value).toDate() : undefined}
                  showNeighboringMonth={true}
                  showFixedNumberOfWeeks={false}
                  showDoubleView={true}
                  defaultActiveStartDate={
                    props.value ? dayjs(props.value).toDate() 
                      : props.minDate ? props.minDate
                      : props.maxDate ? props.maxDate
                      : undefined}
                  tileDisabled={
                    props.tileDisabled
                      ? ({ activeStartDate, date, view }) => {
                          return props.tileDisabled(date);
                        }
                      : undefined
                  }
                  onChange={(value: any) => {
                    const date = new Date(value)
                    const dateConverted = dayjs(date).format("YYYY-MM-DD")

                    props.onChange ? props.onChange(dateConverted) : null

                    setTimeout(() => {
                      setIsCalendarVisible(false)
                    }, 300)
                  }}
                />
              )}
            </div>
          )
        }}
      />
    </div>
  )
}

export default DatePicker
